import { throttle as _throttle } from 'lodash-es'
import * as Sentry from '@sentry/vue'
import BaseWebSocketSubscriber from './base.websocket.subscriber'

const MESSAGE_TYPES = {
  PATCH_SLIDE_OPTIONS: 'patch-slide-options',
}

class SlideOptionsWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.listenEvents()
  }

  listenEvents() {
    this.socketClient.on(MESSAGE_TYPES.PATCH_SLIDE_OPTIONS, _throttle(this.handleSlideOption.bind(this), 600))
  }

  handleSlideOption(doc) {
    const slide = this.$store.getters.activeActivity
    if (slide.id !== doc.slideId) return
    const { SlideOptions } = slide
    let totalVoteCount = 0
    SlideOptions.forEach((item) => {
      if (!item.votesCount) item.votesCount = 0
      const index = doc.slideOptions.findIndex((op) => {
        return op.id == item.id
      })
      if (index !== -1) {
        item.votesCount = doc.slideOptions[index].votesCount
      }
      totalVoteCount += item.votesCount
    })

    if (slide.showPercentage) {
      try {
        SlideOptions.forEach((item) => {
          item.votesCountValue = Number(`${Math.round(`${(item.votesCount / totalVoteCount) * 100}e1`)}e-1`)
        })
      } catch (error) {
        Sentry.captureException(error)
        SlideOptions.forEach((item) => {
          item.votesCountValue = item.votesCount
        })
      }
    } else {
      SlideOptions.forEach((item) => {
        item.votesCountValue = item.votesCount
      })
    }

    this.$store.dispatch('updateSlide', {
      SlideOptions,
    })
  }
}

export default SlideOptionsWebSocketSubscriber
